import type { ReactNode } from 'react';

import { Box } from 'components/Box/Box';
import { colors } from 'theme/theme';

type Props = {
  children: ReactNode;
};

export function Container({ children }: Props) {
  return (
    <Box
      data-qa-id="job-selector"
      overflow="hidden"
      px="4px"
      py="1px"
      bg={colors.backgroundGrey}
      borderRadius="4px"
    >
      {children}
    </Box>
  );
}
